import script from "./FilterItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterItem.vue?vue&type=script&lang=ts&setup=true"

import "./FilterItem.vue?vue&type=style&index=0&id=0d028d74&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d028d74"]])

export default __exports__